/* ============================================================
   OSMANLI DOĞAL TAŞ — Numeroloji 3B katmanı
   Canvas 2D + elle perspektif projeksiyon (WebGL yok).
     1) Mistik Mühür — merkezde Yaşam Yolu glifi, çevresinde dönen tılsım halkaları
     2) Lo Shu Tablet — taşa oyulmuş 3×3 kare, dolu hanelerden yükselen ışık huzmesi
     3) Rakam Alanı   — soru ekranı arka planı, derinlikte süzülen rakamlar

   NOT: (1) ve (2) 2026-08-05'te yeniden tasarlandı. İlk sürüm "merkez küre +
   yörünge" ve "yükselen sütun" kullanıyordu; ikisi de bilimsel görsel dile
   (atom modeli / çubuk grafik) kayıyor ve sayfanın mistik tonuna aykırıydı.
   Eski sürüm: yedek-kure-atom-modeli.js
   ============================================================ */
(function (g) {
  'use strict';

  var AZ_HAREKET = false;
  try {
    AZ_HAREKET = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { }

  /** Canvas'ı devicePixelRatio'ya göre ölçekler; CSS boyutu ile çizim boyutunu ayırır. */
  function hazirla(cv) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = cv.clientWidth || 320, h = cv.clientHeight || 320;
    if (cv.width !== Math.round(w * dpr) || cv.height !== Math.round(h * dpr)) {
      cv.width = Math.round(w * dpr);
      cv.height = Math.round(h * dpr);
    }
    var ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { ctx: ctx, w: w, h: h };
  }

  /** Görünür değilken animasyonu durdurur — mobilde pil ve akıcılık için. */
  function gorunurlukBagla(cv, durum) {
    if (!window.IntersectionObserver) { durum.gorunur = true; return; }
    var io = new IntersectionObserver(function (girdi) {
      durum.gorunur = girdi[0].isIntersecting;
    }, { threshold: 0.01 });
    io.observe(cv);
    durum.gorunur = true;
    return io;
  }

  /* ---------- 3B yardımcıları ---------- */

  function dondurY(p, a) {
    var c = Math.cos(a), s = Math.sin(a);
    return { x: p.x * c + p.z * s, y: p.y, z: -p.x * s + p.z * c };
  }
  function dondurX(p, a) {
    var c = Math.cos(a), s = Math.sin(a);
    return { x: p.x, y: p.y * c - p.z * s, z: p.y * s + p.z * c };
  }
  /** Perspektif: uzaktaki küçülür. d = kamera mesafesi. */
  function yansit(p, cx, cy, d) {
    var f = d / (d + p.z);
    return { x: cx + p.x * f, y: cy + p.y * f, f: f, z: p.z };
  }

  /* ============================================================
     1) MİSTİK MÜHÜR — Yaşam Yolu tılsımı

     TASARIM NOTU: Önceki sürüm "merkezde büyük küre + yörüngede küçük küreler"
     idi; bu şekil kültürel olarak ATOM MODELİ okunuyor (Bohr kabukları) ve
     mistik değil bilimsel duruyordu. Yerine tılsım/mühür dili kondu:
       · yörünge yerine ters yönlerde dönen konsantrik HALKALAR
       · küre yerine ışıkla yazılmış GLİF (rakam)
       · halkalar üzerinde kadim işaretler ve ışın saçakları
       · dış çemberde 9 sabit hane; kullanıcının sayıları yanıyor
     ============================================================ */
  var ISARET = ['✦', '◇', '✧', '◈', '·', '✵', '◦', '✶', '·'];

  function sayiKuresi(cv, veri) {
    /* veri = { merkez:{sayi,renk,renk2,ad}, dugum:[{sayi,renk,etiket}] } */
    var durum = { calisiyor: true, gorunur: true, aci: 0, surukle: null };
    gorunurlukBagla(cv, durum);

    var yildiz = [];
    for (var i = 0; i < 70; i++) {
      yildiz.push({ a: Math.random() * 6.2832, r: 0.55 + Math.random() * 0.75, p: Math.random() * 6.28 });
    }

    /* üç halka: farklı yarıçap, farklı hız, dönüş yönleri ters */
    var halkalar = [
      { r: 0.52, hiz:  0.0038, kalin: 1.1, isaret: 12 },
      { r: 0.70, hiz: -0.0026, kalin: 1.0, isaret: 18 },
      { r: 0.88, hiz:  0.0016, kalin: 1.4, isaret: 9 }
    ];

    function bas(e) { durum.surukle = { x: (e.touches ? e.touches[0] : e).clientX, aci: durum.aci }; }
    function hareket(e) {
      if (!durum.surukle) return;
      var x = (e.touches ? e.touches[0] : e).clientX;
      durum.aci = durum.surukle.aci + (x - durum.surukle.x) * 0.006;
      if (e.cancelable && e.touches) e.preventDefault();
    }
    function birak() { durum.surukle = null; }
    cv.addEventListener('mousedown', bas);
    cv.addEventListener('touchstart', bas, { passive: true });
    window.addEventListener('mousemove', hareket);
    cv.addEventListener('touchmove', hareket, { passive: false });
    window.addEventListener('mouseup', birak);
    window.addEventListener('touchend', birak);

    var t = 0;
    function cerceve() {
      if (!durum.calisiyor) return;
      requestAnimationFrame(cerceve);
      if (!durum.gorunur) return;

      var h = hazirla(cv), ctx = h.ctx, w = h.w, hh = h.h;
      var cx = w / 2, cy = hh / 2;
      var R = Math.min(w, hh) * 0.46;      /* en dış halka */
      var m = veri.merkez;

      ctx.clearRect(0, 0, w, hh);
      t += 1;
      var el = durum.surukle ? 0 : (AZ_HAREKET ? 0 : 1);

      /* --- yıldız tozu (dairesel dağılım) --- */
      yildiz.forEach(function (s) {
        var rr = R * s.r * 1.08;
        var x = cx + Math.cos(s.a + durum.aci * 0.15) * rr;
        var y = cy + Math.sin(s.a + durum.aci * 0.15) * rr;
        var par = 0.14 + 0.2 * Math.sin(t * 0.02 + s.p);
        ctx.fillStyle = 'rgba(210,196,255,' + par.toFixed(3) + ')';
        ctx.fillRect(x, y, 1.4, 1.4);
      });

      /* --- merkez hale --- */
      var hale = ctx.createRadialGradient(cx, cy, R * 0.04, cx, cy, R * 0.62);
      hale.addColorStop(0, m.renk + 'cc');
      hale.addColorStop(0.30, m.renk + '3d');
      hale.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = hale;
      ctx.beginPath(); ctx.arc(cx, cy, R * 0.62, 0, 6.2832); ctx.fill();

      /* --- ışın saçakları (sakral geometri hissi) --- */
      var isinN = 24;
      for (var k = 0; k < isinN; k++) {
        var a = (k / isinN) * 6.2832 + durum.aci * 0.4;
        var uzun = (k % 3 === 0) ? 0.98 : 0.86;
        var sol = 0.05 + 0.07 * Math.sin(t * 0.02 + k);
        ctx.beginPath();
        ctx.moveTo(cx + Math.cos(a) * R * 0.30, cy + Math.sin(a) * R * 0.30);
        ctx.lineTo(cx + Math.cos(a) * R * uzun, cy + Math.sin(a) * R * uzun);
        ctx.strokeStyle = 'rgba(190,168,255,' + sol.toFixed(3) + ')';
        ctx.lineWidth = 1;
        ctx.stroke();
      }

      /* --- dönen halkalar + üzerlerindeki işaretler --- */
      halkalar.forEach(function (hl, hi) {
        var rr = R * hl.r;
        ctx.beginPath(); ctx.arc(cx, cy, rr, 0, 6.2832);
        ctx.strokeStyle = 'rgba(178,156,240,' + (0.16 + hi * 0.05).toFixed(3) + ')';
        ctx.lineWidth = hl.kalin; ctx.stroke();

        var don = durum.aci * (hi + 1) * 0.5 + t * hl.hiz * el;
        for (var s2 = 0; s2 < hl.isaret; s2++) {
          var aa = (s2 / hl.isaret) * 6.2832 + don;
          var x = cx + Math.cos(aa) * rr, y = cy + Math.sin(aa) * rr;
          var par2 = 0.30 + 0.28 * Math.sin(t * 0.025 + s2 + hi);
          ctx.fillStyle = 'rgba(214,198,255,' + par2.toFixed(3) + ')';
          ctx.font = Math.round(R * 0.055) + 'px ui-sans-serif, system-ui, sans-serif';
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(ISARET[(s2 + hi) % ISARET.length], x, y);
        }
      });

      /* --- dış çemberde 9 hane; kullanıcının sayıları yanıyor --- */
      var yanan = {};
      (veri.dugum || []).forEach(function (d) { yanan[d.sayi] = d; });
      yanan[m.sayi] = { sayi: m.sayi, renk: m.renk, etiket: '' };

      for (var n = 1; n <= 9; n++) {
        var an = (-90 + (n - 1) * 40) * Math.PI / 180 + durum.aci * 0.22;
        var rx = cx + Math.cos(an) * R * 1.02, ry = cy + Math.sin(an) * R * 1.02;
        var y2 = yanan[n];
        if (y2) {
          var g2 = ctx.createRadialGradient(rx, ry, 0, rx, ry, R * 0.10);
          g2.addColorStop(0, (y2.renk || m.renk) + 'cc');
          g2.addColorStop(1, 'rgba(0,0,0,0)');
          ctx.fillStyle = g2;
          ctx.beginPath(); ctx.arc(rx, ry, R * 0.10, 0, 6.2832); ctx.fill();
          ctx.fillStyle = y2.renk || m.renk;
          ctx.font = '700 ' + Math.round(R * 0.10) + 'px ui-sans-serif, system-ui, sans-serif';
        } else {
          ctx.fillStyle = 'rgba(168,150,215,0.30)';
          ctx.font = '400 ' + Math.round(R * 0.075) + 'px ui-sans-serif, system-ui, sans-serif';
        }
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(String(n), rx, ry);
      }

      /* --- merkez glif: küre değil, ışıkla yazılmış rakam --- */
      var nabiz = AZ_HAREKET ? 1 : 1 + 0.02 * Math.sin(t * 0.03);
      var fs = R * 0.62 * nabiz;

      /* alt katman: yumuşak ışıma */
      ctx.save();
      ctx.shadowColor = m.renk;
      ctx.shadowBlur = R * 0.28;
      ctx.fillStyle = m.renk2 || '#ffffff';
      ctx.font = '200 ' + Math.round(fs) + 'px ui-sans-serif, system-ui, -apple-system, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(String(m.sayi), cx, cy + fs * 0.02);
      ctx.restore();

      /* üst katman: ince çizgi kontur — mühür kazıması hissi */
      ctx.strokeStyle = 'rgba(255,255,255,0.42)';
      ctx.lineWidth = 1;
      ctx.font = '200 ' + Math.round(fs) + 'px ui-sans-serif, system-ui, -apple-system, sans-serif';
      ctx.strokeText(String(m.sayi), cx, cy + fs * 0.02);

      /* --- çekirdek sayıların etiketleri: merkezin altında sıralı --- */
      var etiketler = (veri.dugum || []).filter(function (d) { return d.etiket; });
      if (etiketler.length) {
        var genis = Math.min(w * 0.86, R * 1.85);
        var adim = genis / etiketler.length;
        var by = cy + R * 0.72;
        etiketler.forEach(function (d, di) {
          var ex = cx - genis / 2 + adim * (di + 0.5);
          ctx.fillStyle = d.renk;
          ctx.font = '700 ' + Math.round(R * 0.135) + 'px ui-sans-serif, system-ui, sans-serif';
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(String(d.sayi), ex, by);
          ctx.fillStyle = 'rgba(206,196,240,0.72)';
          ctx.font = '600 ' + Math.max(9, Math.round(R * 0.062)) + 'px ui-sans-serif, system-ui, sans-serif';
          ctx.fillText(d.etiket, ex, by + R * 0.13);
        });
      }

      ctx.textAlign = 'start'; ctx.textBaseline = 'alphabetic';
    }
    requestAnimationFrame(cerceve);

    return {
      durdur: function () {
        durum.calisiyor = false;
        window.removeEventListener('mousemove', hareket);
        window.removeEventListener('mouseup', birak);
        window.removeEventListener('touchend', birak);
      }
    };
  }

  /* ============================================================
     2) LO SHU — oyulmuş taş tablet

     TASARIM NOTU: Önceki sürüm dolu haneleri yükselen SÜTUN olarak çiziyordu;
     bu bir çubuk grafik gibi okunuyordu. Lo Shu efsanede bir kaplumbağa
     kabuğuna kazınmış sihirli karedir — o yüzden şimdi:
       · eğik duran, dokulu bir taş plaka
       · haneler plakaya OYULMUŞ (içbükey gölge)
       · dolu hanelerden yukarı ışık huzmesi yükseliyor (sütun değil, ışın)
       · tamamlanan hatlar tabanda altın ışık izi
     ============================================================ */
  var LOSHU_DIZ = [4, 9, 2, 3, 5, 7, 8, 1, 6];

  function loShu3B(cv, veri) {
    /* veri = { sayim:{1..9->adet}, dizilim:[...], oklar:[[..]], renk, renk2 } */
    /* egim düşük = daha yandan bakış: tepeden bakışta dikey ışık huzmesi
       perspektifte eziliyor ve kısa görünüyordu. */
    var durum = { calisiyor: true, gorunur: true, aci: -0.26, egim: 0.86 };
    gorunurlukBagla(cv, durum);

    var t = 0;
    function cerceve() {
      if (!durum.calisiyor) return;
      requestAnimationFrame(cerceve);
      if (!durum.gorunur) return;

      var h = hazirla(cv), ctx = h.ctx, w = h.w, hh = h.h;
      var cx = w / 2, cy = hh * 0.66, d = 1600;
      var olcek = Math.min(w / 300, hh / 260);
      var adim = 78 * olcek;
      var renk = veri.renk || '#a97cff';
      var renk2 = veri.renk2 || '#e6d8ff';
      var dizilim = veri.dizilim || LOSHU_DIZ;

      ctx.clearRect(0, 0, w, hh);
      t += 1;
      var sal = AZ_HAREKET ? 0 : Math.sin(t * 0.005) * 0.05;
      var aci = durum.aci + sal;

      function nokta(gx, gz, gy) {
        var p0 = { x: (gx - 1) * adim, y: -(gy || 0), z: (gz - 1) * adim };
        return yansit(dondurX(dondurY(p0, aci), durum.egim), cx, cy, d);
      }

      /* --- taş plaka --- */
      var kose = [nokta(-0.62, -0.62), nokta(2.62, -0.62), nokta(2.62, 2.62), nokta(-0.62, 2.62)];
      ctx.beginPath();
      ctx.moveTo(kose[0].x, kose[0].y);
      kose.slice(1).forEach(function (k) { ctx.lineTo(k.x, k.y); });
      ctx.closePath();
      var tg = ctx.createLinearGradient(kose[0].x, kose[0].y, kose[2].x, kose[2].y);
      tg.addColorStop(0, 'rgba(84,66,138,0.97)');
      tg.addColorStop(0.5, 'rgba(58,43,104,0.97)');
      tg.addColorStop(1, 'rgba(38,27,72,0.97)');
      ctx.fillStyle = tg; ctx.fill();
      ctx.strokeStyle = 'rgba(206,186,250,0.5)'; ctx.lineWidth = 1.6; ctx.stroke();

      /* taş dokusu: ince rastgele çizikler (sabit desen) */
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(kose[0].x, kose[0].y);
      kose.slice(1).forEach(function (k) { ctx.lineTo(k.x, k.y); });
      ctx.closePath(); ctx.clip();
      for (var c = 0; c < 26; c++) {
        var f1 = ((c * 37) % 100) / 100, f2 = ((c * 61) % 100) / 100;
        var p1 = nokta(-0.6 + f1 * 3.2, -0.6 + f2 * 3.2);
        var p2 = nokta(-0.6 + f1 * 3.2 + 0.22, -0.6 + f2 * 3.2 + 0.10);
        ctx.beginPath(); ctx.moveTo(p1.x, p1.y); ctx.lineTo(p2.x, p2.y);
        ctx.strokeStyle = 'rgba(255,255,255,0.055)'; ctx.lineWidth = 1; ctx.stroke();
      }
      ctx.restore();

      /* --- ızgara oyukları --- */
      ctx.strokeStyle = 'rgba(206,186,250,0.22)'; ctx.lineWidth = 1;
      for (var k2 = 0; k2 <= 3; k2++) {
        var a1 = nokta(k2 - 0.5, -0.5), a2 = nokta(k2 - 0.5, 2.5);
        ctx.beginPath(); ctx.moveTo(a1.x, a1.y); ctx.lineTo(a2.x, a2.y); ctx.stroke();
        var b1 = nokta(-0.5, k2 - 0.5), b2 = nokta(2.5, k2 - 0.5);
        ctx.beginPath(); ctx.moveTo(b1.x, b1.y); ctx.lineTo(b2.x, b2.y); ctx.stroke();
      }

      /* --- oklar: taşa kazınmış altın hat --- */
      (veri.oklar || []).forEach(function (ok, oi) {
        var yol = ok.map(function (dv) {
          var idx = dizilim.indexOf(dv);
          return nokta(idx % 3, Math.floor(idx / 3), 1);
        });
        var par = 0.40 + 0.26 * Math.sin(t * 0.028 + oi);
        ctx.beginPath();
        ctx.moveTo(yol[0].x, yol[0].y);
        yol.slice(1).forEach(function (p) { ctx.lineTo(p.x, p.y); });
        ctx.strokeStyle = 'rgba(255,232,160,' + par.toFixed(3) + ')';
        ctx.lineWidth = 4.5 * olcek; ctx.lineCap = 'round'; ctx.stroke();
        ctx.strokeStyle = 'rgba(255,248,214,' + (par * 0.5).toFixed(3) + ')';
        ctx.lineWidth = 1.6 * olcek; ctx.stroke();
      });

      /* --- haneler: arkadan öne --- */
      var hucre = [];
      for (var i = 0; i < 9; i++) {
        hucre.push({ deger: dizilim[i], gx: i % 3, gz: Math.floor(i / 3),
                     adet: (veri.sayim || {})[dizilim[i]] || 0 });
      }
      hucre.sort(function (a, b) { return (a.gz + a.gx) - (b.gz + b.gx); });

      hucre.forEach(function (c2) {
        var dolu = c2.adet > 0;
        var mrk = nokta(c2.gx, c2.gz);

        /* oyuk: içbükey gölge halkası */
        var oy = ctx.createRadialGradient(mrk.x, mrk.y - 2, 1, mrk.x, mrk.y, 26 * olcek);
        oy.addColorStop(0, 'rgba(0,0,0,0.42)');
        oy.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = oy;
        ctx.beginPath(); ctx.arc(mrk.x, mrk.y, 26 * olcek, 0, 6.2832); ctx.fill();

        if (dolu) {
          /* ışık huzmesi: yukarı doğru incelen, sönümlenen ışın */
          /* Huzme rakamın ÜSTÜNDEN başlar; tabandan başlayınca rakamı örtüyordu. */
          var yuk = (135 + (c2.adet - 1) * 46) * olcek;
          var tabanY = mrk.y - 15 * olcek;
          var ust = nokta(c2.gx, c2.gz, yuk);
          var genisAlt = 10 * olcek, genisUst = 1.1 * olcek;
          var hg = ctx.createLinearGradient(mrk.x, tabanY, ust.x, ust.y);
          hg.addColorStop(0, renk + '00');
          hg.addColorStop(0.12, renk + 'a6');
          hg.addColorStop(0.42, renk + '4a');
          hg.addColorStop(0.78, renk + '14');
          hg.addColorStop(1, 'rgba(0,0,0,0)');
          ctx.beginPath();
          ctx.moveTo(mrk.x - genisAlt, tabanY);
          ctx.lineTo(mrk.x + genisAlt, tabanY);
          ctx.lineTo(ust.x + genisUst, ust.y);
          ctx.lineTo(ust.x - genisUst, ust.y);
          ctx.closePath();
          ctx.fillStyle = hg; ctx.fill();

          /* huzme içinde yükselen parçacıklar */
          if (!AZ_HAREKET) {
            for (var pi = 0; pi < c2.adet + 1; pi++) {
              var ilerle = ((t * 0.010) + pi * 0.34 + c2.gx * 0.19 + c2.gz * 0.27) % 1;
              var px = mrk.x + (ust.x - mrk.x) * ilerle;
              var py = tabanY + (ust.y - tabanY) * ilerle;
              var sol2 = (1 - ilerle) * 0.85;
              ctx.fillStyle = renk2 + Math.round(sol2 * 255).toString(16).padStart(2, '0');
              ctx.beginPath(); ctx.arc(px, py, (2.4 - ilerle * 1.2) * olcek, 0, 6.2832); ctx.fill();
            }
          }

          /* taban parıltısı */
          var tp = ctx.createRadialGradient(mrk.x, mrk.y, 1, mrk.x, mrk.y, 24 * olcek);
          tp.addColorStop(0, renk + '77');
          tp.addColorStop(1, 'rgba(0,0,0,0)');
          ctx.fillStyle = tp;
          ctx.beginPath(); ctx.arc(mrk.x, mrk.y, 22 * olcek, 0, 6.2832); ctx.fill();
        }

        /* rakam: kazıma görünümü (gölge + ışık) */
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        var fs = Math.round((dolu ? 25 : 21) * olcek);
        ctx.font = (dolu ? '700 ' : '400 ') + fs + 'px ui-sans-serif, system-ui, sans-serif';
        /* oyuk gölgesi */
        ctx.fillStyle = 'rgba(0,0,0,0.55)';
        ctx.fillText(String(c2.deger), mrk.x + 1, mrk.y + 1.4);
        /* yüzey */
        ctx.fillStyle = dolu ? renk2 : 'rgba(176,158,222,0.42)';
        ctx.fillText(String(c2.deger), mrk.x, mrk.y);

        /* tekrar rozeti */
        if (c2.adet > 1) {
          var kx = mrk.x + 21 * olcek, ky = mrk.y - 16 * olcek;
          ctx.fillStyle = 'rgba(58,40,12,0.9)';
          ctx.beginPath(); ctx.arc(kx, ky, 9 * olcek, 0, 6.2832); ctx.fill();
          ctx.strokeStyle = 'rgba(255,232,160,0.65)'; ctx.lineWidth = 1; ctx.stroke();
          ctx.fillStyle = 'rgba(255,238,180,0.98)';
          ctx.font = '700 ' + Math.round(10.5 * olcek) + 'px ui-sans-serif, system-ui, sans-serif';
          ctx.fillText('×' + c2.adet, kx, ky);
        }
      });

      ctx.textAlign = 'start'; ctx.textBaseline = 'alphabetic';
    }
    requestAnimationFrame(cerceve);
    return { durdur: function () { durum.calisiyor = false; } };
  }

  /* ============================================================
     3) RAKAM ALANI — soru ekranı arka planı
     ============================================================ */
  function rakamAlani(cv, renk) {
    var durum = { calisiyor: true, gorunur: true, renk: renk || '#a97cff' };
    gorunurlukBagla(cv, durum);

    var par = [];
    for (var i = 0; i < 58; i++) {
      par.push({
        x: (Math.random() - 0.5) * 1000,
        y: (Math.random() - 0.5) * 700,
        z: Math.random() * 1000,
        n: 1 + Math.floor(Math.random() * 9),
        s: 0.4 + Math.random() * 0.9
      });
    }

    var t = 0;
    function cerceve() {
      if (!durum.calisiyor) return;
      requestAnimationFrame(cerceve);
      if (!durum.gorunur) return;

      var h = hazirla(cv), ctx = h.ctx, w = h.w, hh = h.h;
      var cx = w / 2, cy = hh / 2;
      ctx.clearRect(0, 0, w, hh);
      t += 1;

      par.sort(function (a, b) { return b.z - a.z; });
      par.forEach(function (p) {
        if (!AZ_HAREKET) {
          p.z -= p.s * 1.5;
          if (p.z < 20) {
            p.z = 1000;
            p.x = (Math.random() - 0.5) * 1000;
            p.y = (Math.random() - 0.5) * 700;
            p.n = 1 + Math.floor(Math.random() * 9);
          }
        }
        var f = 420 / (420 + p.z);
        var x = cx + p.x * f, y = cy + p.y * f;
        if (x < -40 || x > w + 40 || y < -40 || y > hh + 40) return;
        var op = Math.min(0.42, f * 0.62) * (0.55 + 0.45 * Math.sin(t * 0.012 + p.n));
        ctx.fillStyle = durum.renk + Math.round(op * 255).toString(16).padStart(2, '0');
        ctx.font = '700 ' + Math.max(9, Math.round(46 * f)) + 'px ui-sans-serif, system-ui, sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(String(p.n), x, y);
      });
      ctx.textAlign = 'start'; ctx.textBaseline = 'alphabetic';
    }
    requestAnimationFrame(cerceve);

    return {
      durdur: function () { durum.calisiyor = false; },
      renkAyarla: function (r) { durum.renk = r; }
    };
  }

  g.ODTKure = { sayiKuresi: sayiKuresi, loShu3B: loShu3B, rakamAlani: rakamAlani, AZ_HAREKET: AZ_HAREKET };
})(typeof window !== 'undefined' ? window : globalThis);
